export const AccountStatus = [
  'ACTIVE',
  'CLOSED'
]
